/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Location,
  LocationInput,
  Locations,
  LocationsParams,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Locations list
 */
export const locations = (
    params?: MaybeRefOrGetter<LocationsParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Locations>(
      {url: `/locations`, method: 'GET',
        params, signal
    },
      );
    }




export const getLocationsQueryKey = (params?: MaybeRefOrGetter<LocationsParams>,) => {
    return [
    'locations', ...(params ? [params] : [])
    ] as const;
    }


export const getLocationsQueryOptions = <TData = Awaited<ReturnType<typeof locations>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<LocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locations>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof locations>>> = ({ signal }) => locations(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof locations>>, TError, TData>
}

export type LocationsQueryResult = NonNullable<Awaited<ReturnType<typeof locations>>>
export type LocationsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Locations list
 */

export function useLocations<TData = Awaited<ReturnType<typeof locations>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<LocationsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof locations>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Location Detail
 */
export const location = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Location>(
      {url: `/locations/${id}`, method: 'GET', signal
    },
      );
    }




export const getLocationQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'locations',id
    ] as const;
    }


export const getLocationQueryOptions = <TData = Awaited<ReturnType<typeof location>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof location>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getLocationQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof location>>> = ({ signal }) => location(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof location>>, TError, TData>
}

export type LocationQueryResult = NonNullable<Awaited<ReturnType<typeof location>>>
export type LocationQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Location Detail
 */

export function useLocation<TData = Awaited<ReturnType<typeof location>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof location>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLocationQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Location
 */
export const updateLocation = (
    id: MaybeRefOrGetter<string>,
    locationInput: MaybeRefOrGetter<LocationInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
locationInput = toValue(locationInput);

      return axiosClient<Location>(
      {url: `/locations/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: locationInput, signal
    },
      );
    }




export const getUpdateLocationMutationKey = () => ['updateLocation'] as const;

export const getUpdateLocationMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,UpdateLocationMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,UpdateLocationMutationVariables, TContext> => {

const mutationKey = getUpdateLocationMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLocation>>, UpdateLocationMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateLocation(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLocationMutationResult = NonNullable<Awaited<ReturnType<typeof updateLocation>>>
    export type UpdateLocationMutationBody = LocationInput
    export type UpdateLocationMutationError = ErrorType<ValidationError | StandardError>
    export type UpdateLocationMutationVariables = {id: string;data: LocationInput}

    /**
 * @summary Update Location
 */
export const useUpdateLocation = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLocation>>, TError,UpdateLocationMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateLocation>>,
        TError,
        UpdateLocationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLocationMutationOptions(options), queryClient);
    }
